module.exports = require("./js/angular-daterangepicker.js");


//////////////////
// WEBPACK FOOTER
// angular-daterangepicker (bower component)
// module id = 426
// module chunks = 0